import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }

  copy(event) {
    event.preventDefault()

    const textToCopy = this.contentValue

    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Modern clipboard API
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.showFeedback()
        })
        .catch(err => {
          console.error('Failed to copy to clipboard:', err)
          this.showError()
        })
    } else {
      // Fallback for older browsers
      this.fallbackCopy(textToCopy)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.left = "-999999px"
    textArea.style.top = "-999999px"
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.showFeedback()
      } else {
        this.showError()
      }
    } catch (err) {
      console.error('Fallback copy failed:', err)
      this.showError()
    }

    document.body.removeChild(textArea)
  }

  showFeedback() {
    const button = this.element
    const originalHTML = button.innerHTML
    const originalClasses = button.className

    // Show checkmark icon and update styling
    button.innerHTML = `
      <svg class="w-3 h-3 sm:w-4 sm:h-4 sm:mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      <span class="hidden sm:inline">Copied!</span>
    `
    button.classList.add('text-emerald-600', 'border-emerald-300', 'bg-emerald-50')
    button.classList.remove('text-gray-400', 'text-gray-700', 'hover:text-gray-600', 'hover:bg-gray-50')

    // Revert after 2 seconds
    setTimeout(() => {
      button.innerHTML = originalHTML
      button.className = originalClasses
    }, 2000)
  }

  showError() {
    const button = this.element
    const originalHTML = button.innerHTML
    const originalClasses = button.className

    // Show error state
    button.innerHTML = `
      <svg class="w-3 h-3 sm:w-4 sm:h-4 sm:mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
      <span class="hidden sm:inline">Failed</span>
    `
    button.classList.add('text-red-600', 'border-red-300', 'bg-red-50')

    // Revert after 2 seconds
    setTimeout(() => {
      button.innerHTML = originalHTML
      button.className = originalClasses
    }, 2000)
  }
}
